export default __webpack_public_path__ + "static/media/2_Intro.8ae52fa5.mp4";